import React from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaChevronRight
} from "react-icons/fa";
import "../Css/Footer.css";
import logo from "../assets/svk-maid-logo.png";

const Footer = () => {
  // Get current path for active link highlighting
  const currentPath = window.location.pathname;

  return (
    <footer className="main-footer">
      <div className="footer-top">
        <div className="footer-container">
          
          {/* BRAND SECTION */}
          <div className="footer-col brand-col">
            <img src={logo} alt="Tanya Maid Service" className="footer-logo" />
            <p className="footer-desc">
              Tanya Maid Service is your premier choice for professional, reliable, and high-quality home care services in Mumbai. Your comfort is our mission.
            </p>
            <div className="footer-socials">
              <a href="https://www.instagram.com/tanya_maid_service/" className="social-btn" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
              <a href="https://www.facebook.com/tanyamaidservice" className="social-btn" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
              <a href="https://www.linkedin.com/company/tanya-maid-service/" className="social-btn" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
            </div>
          </div>

          {/* QUICK LINKS with Active State */}
          <div className="footer-col">
            <h4 className="footer-title">Quick Links</h4>
            <ul className="footer-links">
              <li>
                <a href="/" className={currentPath === "/" ? "active" : ""}>
                  <FaChevronRight className="bullet" /> Home
                </a>
              </li>
              <li>
                <a href="/about-us" className={currentPath === "/about-us" ? "active" : ""}>
                  <FaChevronRight className="bullet" /> About Us
                </a>
              </li>
              <li>
                <a href="/faq" className={currentPath === "/faq" ? "active" : ""}>
                  <FaChevronRight className="bullet" /> FAQs
                </a>
              </li>
              <li>
                <a href="/contact" className={currentPath === "/contact" ? "active" : ""}>
                  <FaChevronRight className="bullet" /> Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* SERVICES LINKS with Active State */}
          <div className="footer-col">
            <h4 className="footer-title">Our Services</h4>
            <ul className="footer-links">
              <li>
                <a href="/services/patient-care" className={currentPath === "/services/patient-care" ? "active" : ""}>
                  <FaChevronRight className="bullet" /> Patient Care
                </a>
              </li>
              <li>
                <a href="/services/baby-care" className={currentPath === "/services/baby-care" ? "active" : ""}>
                  <FaChevronRight className="bullet" /> Baby Care
                </a>
              </li>
              <li>
                <a href="/services/house-maid" className={currentPath === "/services/house-maid" ? "active" : ""}>
                  <FaChevronRight className="bullet" /> House Maid
                </a>
              </li>
              <li>
                <a href="/services/cooking" className={currentPath === "/services/cooking" ? "active" : ""}>
                  <FaChevronRight className="bullet" /> Cooking Service
                </a>
              </li>
              <li>
                <a href="/services/driver" className={currentPath === "/services/driver" ? "active" : ""}>
                  <FaChevronRight className="bullet" /> Driver
                </a>
              </li>
              <li>
                <a href="/services/home-cleaning" className={currentPath === "/services/home-cleaning" ? "active" : ""}>
                  <FaChevronRight className="bullet" /> Home Cleaning
                </a>
              </li>
              <li>
                <a href="/services/japa-maid" className={currentPath === "/services/japa-maid" ? "active" : ""}>
                  <FaChevronRight className="bullet" /> Japa Maid
                </a>
              </li>
            </ul>
          </div>

          {/* CONTACT INFO */}
          <div className="footer-col">
            <h4 className="footer-title">Contact Info</h4>
            <ul className="contact-list">
              <li className="address-item">
                <FaMapMarkerAlt className="c-icon" />

                <a
                  href="https://maps.app.goo.gl/yEW8FqFS8JXqw27Y6"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="address-link"
                >
                  Block No.317, Rajasthan Compound, Western Express Highway, Near Virwani Industrial Estate, Goregaon (E), Mumbai-63
                </a>
              </li>

              <li>
                <FaPhoneAlt className="c-icon" />
                <a href="tel:+917304398067" className="contact-link">+91 73043 98067</a>
              </li>
              <li>
                <FaEnvelope className="c-icon" />
                <a href="mailto:info@tanyamaidservice.com" className="contact-link">info@tanyamaidservice.com</a>
              </li>
            </ul>
          </div>

        </div>
      </div>

      {/* BOTTOM BAR */}
      <div className="footer-bottom">
        <div className="bottom-container">
          <p>© {new Date().getFullYear()} Tanya Maid Services. All Rights Reserved.</p>
          {/* <p>DESIGN AND DEVELOPED BY<a href="" target="_blank" rel="noopener noreferrer" style={{textDecoration:"none"}}><b style={{color:"#00B8F0"}}> SABAT DIGI SOULTION</b></a></p> */}
          <div className="bottom-links">
            <a href="/privacy-policy">Privacy Policy</a>
            <span className="separator">|</span>
            <a href="/terms-conditions">Terms & Conditions</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;